// extracted by mini-css-extract-plugin
module.exports = {"root":"searchField_root__J40vx","input_clear":"searchField_input_clear__lvzG2"};